var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgStackIcon3(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "50px",
    height: "50px",
    viewBox: "0 0 50 50",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Code Documentation") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "75.4765625%",
    y1: "91.8652344%",
    x2: "23.3007812%",
    y2: "9.76367188%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#85C26A",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#CCF5BA",
    offset: "100%"
  })), /*#__PURE__*/React.createElement("filter", {
    x: "-8.8%",
    y: "-15.0%",
    width: "117.6%",
    height: "130.0%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "SourceGraphic"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Home",
    transform: "translate(-185.000000, -2878.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-44-Copy-2",
    transform: "translate(150.000000, 2819.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-26",
    transform: "translate(35.000000, 54.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Code-Documentation",
    transform: "translate(0.000000, 5.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval",
    fill: "url(#linearGradient-1)",
    cx: 25,
    cy: 25,
    r: 25
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9,37 C8.44771525,37 8,36.5522847 8,36 L8,35 C8,34.4477153 8.44771525,34 9,34 L10,34 L10,18 C10,17.4477153 10.4477153,17 11,17 L39,17 C39.5522847,17 40,17.4477153 40,18 L40,34 L41,34 C41.5522847,34 42,34.4477153 42,35 L42,36 C42,36.5522847 41.5522847,37 41,37 L9,37 Z",
    id: "Combined-Shape",
    fill: "#8DC774",
    filter: "url(#filter-2)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 15.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3,0 L31,0 C31.5522847,-1.01453063e-16 32,0.44771525 32,1 L32,19 C32,19.5522847 31.5522847,20 31,20 L3,20 C2.44771525,20 2,19.5522847 2,19 L2,1 C2,0.44771525 2.44771525,-1.20591542e-16 3,0 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-61",
    transform: "translate(7.000000, 4.000000)",
    fill: "#85C26A"
  }, /*#__PURE__*/React.createElement("g", {
    id: "stairs",
    transform: "translate(8.000000, 0.000000)",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4583333,2.2 L8.66666667,2.2 C8.36766562,2.2 8.125,2.44639893 8.125,2.75 L8.125,4.95 L4.33333333,4.95 C4.03433228,4.95 3.79166667,5.19639893 3.79166667,5.5 L3.79166667,7.7 L0.541666667,7.7 C0.242665617,7.7 0,7.94639893 0,8.25 L0,10.45 C0,10.7536011 0.242665617,11 0.541666667,11 C0.840667716,11 1.08333333,10.7536011 1.08333333,10.45 L1.08333333,8.8 L4.33333333,8.8 C4.63233438,8.8 4.875,8.55360107 4.875,8.25 L4.875,6.05 L8.66666667,6.05 C8.96566772,6.05 9.20833333,5.80360107 9.20833333,5.5 L9.20833333,3.3 L12.4583333,3.3 C12.7573344,3.3 13,3.05360107 13,2.75 C13,2.44639893 12.7573344,2.2 12.4583333,2.2 Z",
    id: "Path"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.158691406,4.23886719 C0.264617911,4.34642333 0.402943937,4.4 0.541666667,4.4 C0.680389396,4.4 0.818715422,4.34642333 0.924641927,4.23886719 L3.25,1.87800291 L3.25,2.2 C3.25,2.50360107 3.49266562,2.75 3.79166667,2.75 C4.09066772,2.75 4.33333333,2.50360107 4.33333333,2.2 L4.33333333,0.55 C4.33333333,0.499645988 4.32434082,0.451843253 4.31191001,0.405383309 C4.30900065,0.394104012 4.30569459,0.383361825 4.30185952,0.372351066 C4.28704832,0.328039559 4.26826986,0.285742187 4.2434082,0.247473153 C4.24261473,0.246398934 4.24235026,0.245056144 4.24155679,0.243981925 C4.21550496,0.204638672 4.18297323,0.170263672 4.14806112,0.138842756 C4.13972982,0.131188956 4.13100181,0.124072266 4.12214153,0.116821306 C4.08445233,0.0871459875 4.04438274,0.0610962 3.99994915,0.0422973719 C3.99968464,0.0422973719 3.99942017,0.0420288 3.99915567,0.0417602625 C3.99809773,0.0412231531 3.99664308,0.0412231531 3.99532064,0.0409545813 C3.95339967,0.0236328125 3.9081726,0.0134277344 3.86149089,0.00711669063 C3.84906004,0.0055053625 3.83689373,0.00416260625 3.82446289,0.00335693188 C3.81361899,0.00268554688 3.80303957,0 3.79166667,0 L2.16666667,0 C1.86766562,0 1.625,0.246398934 1.625,0.55 C1.625,0.853601066 1.86766562,1.1 2.16666667,1.1 L2.48404948,1.1 L0.158691406,3.46113281 C-0.052764901,3.67597656 -0.052764901,4.02402344 0.158691406,4.23886719 Z",
    id: "Path"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M6,10.338202 C6,8.57346178 4.65685425,7.14285714 3,7.14285714 C1.34314575,7.14285714 0,8.57346178 0,10.338202 C0,11.2303651 6,11.2107792 6,10.338202 Z",
    id: "Oval"
  }), /*#__PURE__*/React.createElement("ellipse", {
    id: "Oval",
    cx: 3,
    cy: 3.92857143,
    rx: 1.8,
    ry: 1.92857143
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group-59",
    transform: "translate(7.000000, 6.000000)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1,17 L33,17 C33.5522847,17 34,17.4477153 34,18 L34,19 C34,19.5522847 33.5522847,20 33,20 L1,20 C0.44771525,20 2.8967998e-16,19.5522847 0,19 L0,18 C-6.76353751e-17,17.4477153 0.44771525,17 1,17 Z",
    id: "Rectangle",
    fill: "#FFFFFF"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStackIcon3);
export default __webpack_public_path__ + "static/media/stack-icon-3.5a8d750e9cf22a9b0eee9621c184f7a4.svg";
export { ForwardRef as ReactComponent };